/**
 * Field mappings for autocomplete prevention
 * Maps DOM field names (texkit* for autocomplete prevention) to API field names
 */
// Common address field mappings used across all payment forms
export const COMMON_ADDRESS_FIELD_MAPPING = {
    texkitaddress: 'streetAddress',
    texkitaddress2: 'streetAddress2',
    texkitcity: 'city',
    texkitzip: 'zip',
    state: 'state', // No autocomplete issues with state
};
// Payment card specific field mappings
export const PAYMENT_CARD_FIELD_MAPPING = {
    ...COMMON_ADDRESS_FIELD_MAPPING,
    texkitname: 'name',
    texkitexpiry: 'expirationDate',
    texkitcardnumber: 'cardNumber',
    cvv: 'cvv', // No autocomplete issues with CVV
};
// Payment card with country specific field mappings
export const PAYMENT_CARD_WITH_COUNTRY_FIELD_MAPPING = {
    ...PAYMENT_CARD_FIELD_MAPPING,
    country: 'country',
    postalCode: 'postalCode', // No autocomplete issues with postal code
};
// ACH payment specific field mappings
export const PAYMENT_ACH_FIELD_MAPPING = {
    ...COMMON_ADDRESS_FIELD_MAPPING,
    texkitaccountname: 'accountName',
    texkitbankname: 'bankName',
    accountType: 'accountType',
    accountNumber: 'accountNumber',
    routingNumber: 'routingNumber',
    acceptTerms: 'acceptTerms',
    texkitAccountdescription: 'accountDescription', // No autocomplete issues
};
const PAYMENT_FORM_VALUE_CHECK_FIELDS_COMMON = [
    'cvv',
    'expirationDate',
    'streetAddress',
    'city',
    'state',
];
export const PAYMENT_FORM_VALUE_CHECK_FIELDS = [
    ...PAYMENT_FORM_VALUE_CHECK_FIELDS_COMMON,
    'zip',
];
export const PAYMENT_FORM_WITH_COUNTRY_VALUE_CHECK_FIELDS = [
    ...PAYMENT_FORM_VALUE_CHECK_FIELDS_COMMON,
    'country',
    'postalCode',
];
export const PAYMENT_ACH_FORM_VALUE_CHECK_FIELDS = [
    'accountName',
    'bankName',
    'routingNumber',
    'accountDescription',
    'streetAddress',
    'city',
    'state',
    'zip',
];
//# sourceMappingURL=fieldMappings.js.map